<template>
  <div class="page">
    <Banner :top="0" />
    <div class="pc_ipad">
      <div class="layer1">
        <div class="left">
          <div class="row row1">
            <div>
              <img
                src="~@/assets/spark-live/2.jpg"
                alt=""
              >
            </div>
            <div class="video">
              <img
                v-if="play1"
                class="play"
                src="~@/assets/spark-mini/play.png"
                alt=""
                @click="videoClick1"
              >
              <video
                ref="videoPlayer1"
                loop
                poster="~@/assets/spark-live/1.jpg"
                @click="videoClick1"
              >
                <source
                  src="https://assets.positivegrid.com.cn/media/wetransfer_spark-live-3_2024-01-25_0947/Spark%20LIVE%20-%20Multi-Channel%20%28Loop%29%20%5B10s%2C%2016x9-H264%5D.mp4"
                  type="video/mp4"
                >
              </video>
            </div>
          </div>
          <div class="row row1">
            <div class="video">
              <img
                v-if="play6"
                class="play"
                src="~@/assets/spark-mini/play.png"
                alt=""
                @click="videoClick6"
              >
              <video
                ref="videoPlayer6"
                loop
                autoplay
                poster="~@/assets/spark-live/4.jpg"
                @click="videoClick6"
              >
                <source
                  src="https://assets.positivegrid.com.cn/media/wetransfer_spark-live-3_2024-01-25_0947/Spark%20LIVE%20-%20Gear%20%28Loop%29%20%5B11s%2C%2016x9-H264-E42%2CCQ%2CRF26%2C1080p%5D.mp4"
                  type="video/mp4"
                >
              </video>
            </div>
            <div>
              <img src="~@/assets/spark-live/3.jpg">
            </div>
          </div>
          <div class="row row1">
            <div>
              <img src="~@/assets/spark-live/6.jpg">
            </div>
            <div class="video">
              <img
                v-if="play1"
                class="play"
                src="~@/assets/spark-mini/play.png"
                alt=""
                @click="videoClick3"
              >
              <video
                ref="videoPlayer3"
                autoplay
                loop
                poster="~@/assets/spark-live/5.jpg"
                @click="videoClick3"
              >
                <source
                  src="https://assets.positivegrid.com.cn/media/wetransfer_spark-live-3_2024-01-25_0947/Spark%20LIVE%20-%20Product%20Exp%20Snapshot%20%28Loop%29%20%5B18s%2C%204x3-H264%5D.mp4"
                  type="video/mp4"
                >
              </video>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="box">
            <img
              class="background"
              src="~@/assets/spark-live/row-right.png"
            >
            <div class="right_btn_box">
              <img
                class="price"
                src="~@/assets/spark-live/3999.png"
              >
              <img
                class="btn"
                src="~@/assets/spark-mini/button.png"
                @click="openTmallFun"
              >
              <div class="download">
                <a
                  :href="androidUrl"
                  download=""
                  style="cursor:pointer"
                  @click="downloadAndroidFun"
                >
                  <img
                    class="anzuo"
                    src="~@/assets/spark-mini/anzuo.png"
                    @click="downloadAndroidFun"
                  >
                </a>
                <img
                  src="~@/assets/spark-mini/ios.png"
                  @click="downIosFun"
                >
                <img
                  class="text"
                  src="~@/assets/spark-mini/text.png"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/born-to-play.png">
        <div class="video">
          <img
            v-if="play8"
            class="play"
            src="~@/assets/spark-mini/play.png"
            alt=""
            @click="videoClick8"
          >
          <video
            ref="videoPlayer8"
            loop
            poster="~@/assets/spark-live/Frame 1819.jpg"
            @click="videoClick8"
          >
            <source
              src="https://pg-cn-assets2.oss-cn-hangzhou.aliyuncs.com/media/spark%20live%E6%AD%A3%E5%BC%8F%E4%B8%AD%E6%96%87tvc.mp4"
              type="video/mp4"
            >
          </video>
        </div>
      </div>
      <div class="layer3">
        <img src="~@/assets/spark-live/multi-channel.png">
      </div>

      <div class="layer4">
        <img src="~@/assets/spark-live/design.png">
        <swiper
          class="swiper"
          :options="swiperOption1"
        >
          <swiper-slide class="width" />
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1848.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1850.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1851.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1852.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1853.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1855.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1856.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1857.png"
            >
          </swiper-slide>
          <swiper-slide class="width" />

          <!-- <div
          slot="pagination"
          class="swiper-pagination"
        /> -->
        </swiper>
      </div>

      <div class="layer5">
        <img src="~@/assets/spark-live/AI .png">
        <swiper
          class="swiper"
          :options="swiperOption1mobile"
        >
          <swiper-slide class="width" />
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper2/App item.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper2/App item-1.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper2/App item-2.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper2/App item-3.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper2/App item-4.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper2/App item-5.png"
            >
          </swiper-slide>
          <swiper-slide class="width" />
        </swiper>
      </div>
      <div class="layer6">
        <img src="~@/assets/spark-live/jishu.png">
      </div>
      <div class="layer7">
        <img src="~@/assets/spark-live/lanya.png">
      </div>
      <div class="layer8">
        <img src="~@/assets/spark-live/sec 3.png">
        <swiper
          class="swiper"
          :options="swiperOption2"
        >
          <swiper-slide class="width" />

          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 1924.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 1926.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18213.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18214.png"
            >
          </swiper-slide>

          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18218.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18219.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18222.png"
            >
          </swiper-slide>
        </swiper>
      </div>
      <div class="layer9">
        <img src="~@/assets/spark-live/Frame 1823.png">
      </div>
      <div class="layer10">
        <img src="~@/assets/spark-live/Frame 1822.png">
      </div>
    </div>

    <!-- 手机版 -->
    <div class="mobile">
      <vue-carousel
        :data="slides"
        :slide-on-swipe="false"
        class="carousel"
      />
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/Frame 18163.png">
        <div
          class="tmall"
          @click="openTmallFun"
        />
        <a
          :href="androidUrl"
          download=""
          style="cursor:pointer"
          class="anzuo"
          @click="downloadAndroidFun"
        />
        <img
          class="ios"
          src="~@/assets/spark-mini/ios.png"
          @click="downIosFun"
        >
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/born to play.png">
        <div class="video">
          <img
            v-if="play5"
            class="play"
            src="~@/assets/spark-mini/play.png"
            alt=""
            @click="videoClick5"
          >
          <video
            ref="videoPlayer5"
            loop
            poster="~@/assets/spark-live/Frame 1819.jpg"
            @click="videoClick5"
          >
            <source
              src="https://pg-cn-assets2.oss-cn-hangzhou.aliyuncs.com/media/spark%20live%E6%AD%A3%E5%BC%8F%E4%B8%AD%E6%96%87tvc.mp4"
              type="video/mp4"
            >
          </video>
        </div>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/multi-channel.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/Frame 1710.png">
      </div>
      <div class="swiper1">
        <swiper
          class="swiper"
          :options="swiperOption1"
        >
          <swiper-slide class="width" />
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1848.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1850.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1851.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1852.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1853.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1855.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1856.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper1/Frame 1857.png"
            >
          </swiper-slide>
        </swiper>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/Frame 1944.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/AI.png">
        <div class="swiper2moblie">
          <swiper
            :options="swiperOption2mobile"
          >
            <swiper-slide>
              <img
                class="swiper_img"
                src="~@/assets/spark-live/swiper2/App item.png"
              >
            </swiper-slide>
            <swiper-slide>
              <img
                class="swiper_img"
                src="~@/assets/spark-live/swiper2/App item-1.png"
              >
            </swiper-slide>
            <swiper-slide>
              <img
                class="swiper_img"
                src="~@/assets/spark-live/swiper2/App item-2.png"
              >
            </swiper-slide>
            <swiper-slide>
              <img
                class="swiper_img"
                src="~@/assets/spark-live/swiper2/App item-3.png"
              >
            </swiper-slide>
            <swiper-slide>
              <img
                class="swiper_img"
                src="~@/assets/spark-live/swiper2/App item-4.png"
              >
            </swiper-slide>
            <swiper-slide>
              <img
                class="swiper_img"
                src="~@/assets/spark-live/swiper2/App item-5.png"
              >
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/jisu.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/lanya.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/Frame 1759.png">
      </div>
      <div class="layer2 layer8moblie">
        <swiper
          class="swiper"
          :options="swiperOption2moblie"
        >
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 1924.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 1926.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18213.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18214.png"
            >
          </swiper-slide>

          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18218.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18219.png"
            >
          </swiper-slide>
          <swiper-slide>
            <img
              class="swiper_img"
              src="~@/assets/spark-live/swiper3/Frame 18222.png"
            >
          </swiper-slide>
        </swiper>
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/Frame 1823.png">
      </div>
      <div class="layer2">
        <img src="~@/assets/spark-live/mobile/Frame 1948.png">
      </div>
    </div>
  </div>
</template>
<script>
import Banner from '@/components/banner'
import VueCarousel from '@chenfengyuan/vue-carousel'
import axios from 'axios'
import { NEW_API_URL } from '@/urls'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  components: {
    Banner,
    VueCarousel,
    swiper,
    swiperSlide
  },
  data () {
    let row1 = require('@/assets/spark-live/1.jpg')
    let row2 = require('@/assets/spark-live/2.jpg')
    let row3 = require('@/assets/spark-live/3.jpg')
    let row4 = require('@/assets/spark-live/4.jpg')
    let row5 = require('@/assets/spark-live/5.jpg')
    let row6 = require('@/assets/spark-live/6.jpg')
    return {
      play1: false,
      play2: true,
      play5: true,
      play6: false,
      play7: false,
      play8: true,
      slides: [
        `<div> <img src="${row1}" > </div>`,
        `<div> <img src="${row2}" > </div>`,
        `<div> <img src="${row3}" > </div>`,
        `<div> <img src="${row4}" > </div>`,
        `<div> <img src="${row5}" > </div>`,
        `<div> <img src="${row6}" > </div>`
      ],
      androidUrl: '',
      num: 0,
      swiperOption1: {
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 20,
        // slidesOffsetBefore: '260%',
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2: {
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 20,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption1mobile: {
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 0,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2mobile: {
        slidesPerView: '1.2',
        loop: false,
        spaceBetween: 0,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      swiperOption2moblie: {
        slidesPerView: '1.3',
        loop: false,
        spaceBetween: 10,
        initialSlide: 3,
        centeredSlides: true,
        freeMode: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  watch: {},
  created () {
    this.downloadAndroidFun()
  },
  methods: {
    videoClick1 () {
      this.play1 = !this.$refs.videoPlayer1.paused

      this.$refs.videoPlayer1.paused === true
        ? this.$refs.videoPlayer1.play()
        : this.$refs.videoPlayer1.pause()
    },
    videoClick2 () {
      this.play2 = !this.$refs.videoPlayer2.paused
      this.$refs.videoPlayer2.paused === true
        ? this.$refs.videoPlayer2.play()
        : this.$refs.videoPlayer2.pause()
    },
    videoClick3 () {
      this.play1 = !this.$refs.videoPlayer3.paused

      this.$refs.videoPlayer3.paused === true
        ? this.$refs.videoPlayer3.play()
        : this.$refs.videoPlayer3.pause()
    },
    videoClick5 () {
      this.play5 = !this.$refs.videoPlayer5.paused

      this.$refs.videoPlayer5.paused === true
        ? this.$refs.videoPlayer5.play()
        : this.$refs.videoPlayer5.pause()
    },
    videoClick6 () {
      this.play6 = !this.$refs.videoPlayer6.paused

      this.$refs.videoPlayer6.paused === true
        ? this.$refs.videoPlayer6.play()
        : this.$refs.videoPlayer6.pause()
    },
    videoClick7 () {
      this.play7 = !this.$refs.videoPlayer7.paused

      this.$refs.videoPlayer7.paused === true
        ? this.$refs.videoPlayer7.play()
        : this.$refs.videoPlayer7.pause()
    },
    videoClick8 () {
      this.play8 = !this.$refs.videoPlayer8.paused

      this.$refs.videoPlayer8.paused === true
        ? this.$refs.videoPlayer8.play()
        : this.$refs.videoPlayer8.pause()
    },
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    openTmallFun () {
      if (this._isMobile()) {
        window.open('https://m.tb.cn/h.5vQDlCYNYMzSUsF?tk=IOKaWmPvbYV')
      } else {
        window.open(
          'https://detail.tmall.com/item.htm?abbucket=17&id=771622615480&ns=1&spm=a21n57.1.0.0.378c523ctNY43K&skuId=5283849656202'
        )
      }
    },
    //   download android
    async downloadAndroidFun () {
      this.num += 1
      try {
        await axios
          .get(`${NEW_API_URL}/api/package/spark`, {
            headers: {
              //   'Authorization': `JWT ${this.token || window.localStorage.getItem('PG_TOKEN')}`,
              'Content-Type': 'application/json;charset=UTF-8'
            }
          })
          .then((res) => {
            if (res.data.android) {
              let userAgent = navigator.userAgent.toLowerCase()
              if (
                userAgent.indexOf('android') > -1 &&
                this.num > 1
              ) {
                window.open(res.data.android.download_url)
              } else {
                this.androidUrl = res.data.android.download_url
              }
            }
          })
          .catch((err) => {
            console.error('Fail!!', err)
          })
      } catch (err) {
        console.log(err, '请求出错！')
      }
    },
    // download ios
    downIosFun () {
      window.open('https://apps.apple.com/cn/app/id1516758668')
    }
  }
}
</script>
<style lang="scss" scoped>
.pc_ipad {
  display: block;
  padding-top: 54px;
}

.mobile {
  display: none;
}

.page {
  // padding-top: 5.5%;
  background: #fff;
  min-height: 100vh;

  .layer1 {
    display: flex;

    .left {
      flex: 1435;
      padding-right: 1%;

      .row {
        display: flex;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 10px;
        .video{
          display: flex;
          background: #000;
        }
        div:nth-child(1) {
          margin-right: 1%;
        }

        div {
          position: relative;
          flex: 1;
          max-width: 100%;

          img,
          video {
            width: 100%;
          }

          .play {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 20%;
          }
        }
      }

      .row:nth-child(3) {
        margin: 0;
      }
    }

    .right {
      flex: 486;
      background: #e02020;
      box-sizing: border-box;
      text-align: center;

      .box {
        margin: 0 auto;
        position: relative;

        .background {
          width: 100%;
        }

        .right_btn_box {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          padding-top: 274%;

          .price {
            width: 80%;
            margin-left: 10%;
            margin-bottom: 10%;
          }

          .btn {
            cursor: pointer;
            width: 70%;
            margin-left: 16%;
            opacity: 0;
          }

          .download {
            opacity: 0;
            margin-top: 23%;
            margin-left: 25%;
            width: 50%;
          }

          .anzuo {
            margin-bottom: 10%;
          }

          .text {
            margin: 0 auto;
            margin-top: 8%;
            width: 50%;
          }
        }
      }
    }
  }

  .layer2 {
    position: relative;

    .video {
      position: absolute;
      bottom: 2%;
      right: 10%;
      display: flex;
      width: 40%;
      height: 12.1%;
      box-sizing: border-box;
      margin-bottom: 10px;

      div:nth-child(1) {
        margin-right: 1%;
      }

      img,
      video {
        width: 100%;
      }

      .play {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 20%;
      }

    }
  }

  .layer3 {
    // margin-top: -25%;
  }

  .layer4 {
    position: relative;

    .swiper {
      position: absolute;
      top: 17%;

      .swiper-slide {
        width: 33%;

      }

      .width {
        width: 17%;
      }
    }
  }

  .layer5 {
    position: relative;

    .swiper {
      position: absolute;
      top: 64%;

      .swiper-slide {
        width: 28%;

      }

      .width {
        width: 13%;
      }
    }
  }

  .layer4,
  .layer5 {
    background-color: #000;
  }

  .layer8 {
    position: relative;

    .swiper {
      position: absolute;
      top: 20%;

      .swiper-slide {
        width: 70%;

      }

      .width {
        width: 16%;
      }

    }
  }

  @media (max-width: 768px) {
    .pc_ipad {
      display: none;
    }

    .mobile {
      min-height: 100%;
      padding-top: 44px;
      background: #fff;
      display: block;

      .carousel {
        height: 100%;
        vertical-align: middle;

      }

      .layer2>img {
        margin-top: -1px;
      }

      .layer2 {
        position: relative;
        text-align: center;

        .right_btn_box {
          width: 100%;
          position: absolute;
          top: 65%;

          .btn {
            margin: 0 auto;
            width: 56%;
          }

          .anzuo {
            margin: 15% auto 0 auto;
            width: 45%;
          }

          .ios {
            margin: 3% auto 0 auto;
            width: 45%;
          }

          .text {
            margin: 3% auto 0 auto;
            width: 25%;
          }
        }

        .tmall {
          position: absolute;
          top: 62.5%;
          left: 27%;
          // background-color: #000;
          width: 46%;
          height: 5%;
        }

        .anzuo {
          position: absolute;
          top: 73.5%;
          left: 29%;
          // background-color: #fff;
          width: 42%;
          height: 6%;
        }

        .ios {
          position: absolute;
          top: 81.5%;
          left: 29%;
          // background-color: #fff;
          width: 42%;
          height: 6%;
        }

        .video {
          position: absolute;
          bottom: 0%;
          left: 4%;
          width: 92%;
        }
        .swiper2moblie{
          position: absolute;
          max-width: 100%;
          bottom: 10%;
        }

      }
      .layer8moblie{
        margin-top: 10%;
      }
       .swiper1{
          background: #000;
          .swiper-container {
            background-color: #000;
          }
          .width{
            width: 0%;
          }
        }

      .layer3 {
        margin-top: 0%;
        position: relative;

        .play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20%;
        }
      }

      // .layer4{
      //   img{
      //     width:100%;
      //   }
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/spark-live.vue